// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const MoneysIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Moneys/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.975 5.533c-.358-1.808-1.7-2.6-3.567-2.6H5.092c-2.2 0-3.667 1.1-3.667 3.667v4.292c0 1.85.758 2.933 2.008 3.4.184.066.384.125.592.158.333.075.692.108 1.067.108h7.325c2.2 0 3.666-1.1 3.666-3.666V6.6c0-.392-.033-.742-.108-1.067ZM4.608 10a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V7.5a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625V10Zm4.142.95c-1.217 0-2.2-.983-2.2-2.2s.983-2.2 2.2-2.2 2.2.983 2.2 2.2-.983 2.2-2.2 2.2Zm5.383-.95a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V7.5a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625V10Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.583 9.1v4.292c0 2.566-1.466 3.675-3.675 3.675H7.592c-.625 0-1.184-.092-1.667-.275a2.81 2.81 0 0 1-1.008-.617c-.15-.142-.034-.367.175-.367h7.316c3.084 0 4.917-1.833 4.917-4.908V6.6c0-.2.225-.325.367-.175.566.6.891 1.475.891 2.675Z"
}));
export default MoneysIcon;